/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Toggle_PlaybackInputs */

const en_shortcut_keys_name_toggle_playback = /** @type {(inputs: Shortcut_Keys_Name_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Playback (Play/Pause)`)
};

const fr_shortcut_keys_name_toggle_playback = /** @type {(inputs: Shortcut_Keys_Name_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer lecture (lecture/pause)`)
};

const de_shortcut_keys_name_toggle_playback = /** @type {(inputs: Shortcut_Keys_Name_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiedergabe umschalten (Wiedergabe/Pause)`)
};

const it_shortcut_keys_name_toggle_playback = /** @type {(inputs: Shortcut_Keys_Name_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva la riproduzione (Riproduci/Pausa)`)
};

const ru_shortcut_keys_name_toggle_playback = /** @type {(inputs: Shortcut_Keys_Name_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить воспроизведение (Воспроизведение/Пауза)`)
};

const es_shortcut_keys_name_toggle_playback = /** @type {(inputs: Shortcut_Keys_Name_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar reproducción (Reproducir/Pausa)`)
};

const zh_cn2_shortcut_keys_name_toggle_playback = /** @type {(inputs: Shortcut_Keys_Name_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换播放（播放/暂停）`)
};

const ja_shortcut_keys_name_toggle_playback = /** @type {(inputs: Shortcut_Keys_Name_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再生の切り替え（再生/一時停止）`)
};

const hi_shortcut_keys_name_toggle_playback = /** @type {(inputs: Shortcut_Keys_Name_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लेबैक टॉगल करें (चलाएँ/रोकें)`)
};

const pt_pt2_shortcut_keys_name_toggle_playback = /** @type {(inputs: Shortcut_Keys_Name_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar reprodução (Reproduzir/Pausar)`)
};

/**
* | output |
* | --- |
* | "Toggle Playback (Play/Pause)" |
*
* @param {Shortcut_Keys_Name_Toggle_PlaybackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_toggle_playback = /** @type {((inputs?: Shortcut_Keys_Name_Toggle_PlaybackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Toggle_PlaybackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_toggle_playback(inputs)
	if (locale === "de") return de_shortcut_keys_name_toggle_playback(inputs)
	if (locale === "it") return it_shortcut_keys_name_toggle_playback(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_toggle_playback(inputs)
	if (locale === "es") return es_shortcut_keys_name_toggle_playback(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_toggle_playback(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_toggle_playback(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_toggle_playback(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_toggle_playback(inputs)
	return en_shortcut_keys_name_toggle_playback(inputs)
});